import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IUpgrade, IUpgradeListado } from "../model/IUpgrade";

export default class UpgradeService extends ServiceBase {
  all = () : Promise<IResponse<IUpgrade[]>> => 
    this.GetFetch<IResponse<IUpgrade[]>>('entity/upgrade/all', {});

  get = (data:{ id?: number }) : Promise<IResponse<IUpgrade>> => 
    this.GetFetch<IResponse<IUpgrade>>('entity/upgrade', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string,
    id?: number, nombre?: string, proveedor?: string, segmento?: string, activo?: boolean }) : Promise<IPaginatedResponse<IUpgradeListado>> => 
    this.GetFetch<IPaginatedResponse<IUpgradeListado>>('entity/upgrade/find', data);

  upsert = (data:IUpgrade) : Promise<IResponse<IUpgrade>> => 
    this.PostFetch<IResponse<IUpgrade>>('entity/upgrade', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/upgrade', data);
}
